import { useState, useRef, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
    AppBar,
    Badge,
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    Divider,
    Grid2 as Grid,
    LinearProgress,
    Toolbar,
    Tooltip,
    Typography,
} from '@mui/material';
import { AccountCircle, Add, Backspace, CallSplit, Check, Checklist, CleanHands, ClearAll, DatasetLinked, Delete, Download, Edit, EmojiEvents, FormatListNumbered, Functions, Info, InsertLink, Message, MilitaryTech, PictureAsPdf, PictureAsPdfSharp, PlayArrow, QrCode, RemoveRedEye, Repartition, Scoreboard, ScreenShare, Stop, VisibilityOff, Warning } from '@mui/icons-material';
import { checkComponentPresence, getSelectedElement, myTimestampToDate, propComparator, propComparatorDate, propComparatorDateTime, myFormat } from "../utils/ui_utils";

import { addMinutes, format } from "date-fns";
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { add_Match, clear_all_matches, delete_Match, edit_Match, get_Match_list } from "../FirebaseUtils/dbMatch";
import { globalstyles } from "../lib/definitions";
import { get_Category_list } from "../FirebaseUtils/dbCategory";
import { useAuth } from "../core/AuthProvider";
import { useEvent } from "../context/eventContext";
import useMediaQuery from '@mui/material/useMediaQuery';
import { award_filter_subdict, cleanMatch, getAwardDescription, getAwardLabel, initCowlist } from "../definitions/match";
import { MyPrivateIcon, RunningMode } from "../components/MyPrivateIcon";
import { SideBadge } from "../components/SideBadge";
import { CowSublistDialog } from "../modals/CowSublistDialog";
import { MatchDialog } from "../modals/MatchDialog";
import { MatchResultDialog } from "../modals/MatchResultDialog";
import { MatchDocumentsDialog } from "../modals/MatchDocumentsDialog";
import { MatchInitWizardDialog } from "../modals/MatchInitWizard";
import { get_event_status_live, set_event_status } from "../FirebaseUtils/dbEvent";
import { get_cows_live } from "../FirebaseUtils/dbCow";
import { MatchSplitDialog } from "../modals/MatchSplitDialog";
import OneMatchMenu from "../components/menu/OneMatchMenu";
import { AwardListDialog } from "../modals/AwardListDialog";
import { AwardListPointDialog } from "../modals/AwardListPointDialog";
import { HtmlTooltip } from "../components/HtmlTooltip";
import MatchpageMenu from "../components/menu/MatchpageMenu";
import TemplateMenu from "../components/menu/TemplateMenu";
import { add_match_complete_template, get_match_complete_template_list } from "../FirebaseUtils/dbSettings";
import { category_section } from "../definitions/category";
import ExportCSV from "../components/ExportCsv";
import ElevationScroll from "../components/ElevationScroll";
import { CowSqualifiedDialog } from "../modals/CowSqualifiedDialog";
import { ExportDataDialog } from "../modals/ExportDataDialog";




export default function MatchPage() {
    const { user } = useAuth()
    const dialogRef = useRef()
    const resultRef = useRef()
    const splitRef = useRef()
    const childRefDelete = useRef()
    const cowlistRef = useRef()
    const awardListRef = useRef()
    const awardListPointRef = useRef()
    const documentRef = useRef()
    const squalifiedRef = useRef()
    const exportRef = useRef()


    const [isLoading, setIsLoading] = useState(true)

    const { selEvent } = useEvent()
    const [event_status, setEventStatus] = useState({})

    const [element_list, setElementList] = useState([])
    const [category_list, setCategoryList] = useState([])
    const [cow_list, setCowList] = useState([])

    const _award_filter_subdict = {
        ...award_filter_subdict,
        ...selEvent.custom_cow_filter_param_list ? Object.assign({}, ...selEvent.custom_cow_filter_param_list.map(x => ({ [x.param_name]: { id: x.param_name, label: x.param_name, color: 'info' } }))) : {}
    }

    const handleNew = () => {
        if (element_list.length > 0) {
            dialogRef.current.onNew(addMinutes(myTimestampToDate(element_list[element_list.length - 1].planned_start), 30))
        } else {
            dialogRef.current.onNew()
        }
    }

    useEffect(() => {
        setIsLoading(false)
    }, [element_list])

    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }
    const handleRun = (r, i, c) => {
        //if (r.award_list?.filter(a => a.from_other_data).length > 0) {
        if (r.match_type === 'auto') {
            awardListPointRef.current.onEdit(r)
        } else {
            if (r.link_to_category) {
                resultRef.current.onOpen(r, i, element_list, cow_list.filter(c => c.category && c.category.id === r.linked_category?.id))
            } else {
                resultRef.current.onOpen(r, i, element_list)
            }
        }
    }
    const handleDocs = (r, i) => {
        const _data = initCowlist(r, element_list, cow_list.filter(c => c.category && c.category.id === r.linked_category?.id))
        documentRef.current.onOpen({
            ...r,
            dynamic_cow_list: _data.dynamic_cow_list,
            linked_cow_list: _data.linked_cow_list
        })
    }
    const handleSplit = (r, i) => {
        splitRef.current.onOpen(r)
    }
    const handlePdfDocs = () => {
        documentRef.current.onOpen(element_list, true, cow_list)
    }

    const showAwardList = (r) => {
        awardListPointRef.current.onEdit(r)
        /*         if (r.award_list?.filter(a => a.from_other_data).length > 0) {
                    awardListPointRef.current.onEdit(r)
                } else {
                    awardListRef.current.onEdit(r)
                } */
    }

    const handleDelete = (r, i) => {
        const cb = async () => {
            delete_Match(selEvent.id, r.id)
            if (r.id) {
                const lm = element_list.filter(m => m.source_list_data && m.source_list_data[r.id])
                if (lm.length > 0) {
                    for (const m of lm) {
                        console.log("EDIT LINKED MATCH", m)
                        let _sd = { ...m.source_list_data }
                        delete _sd[r.id]
                        await edit_Match(user.uid, selEvent.id, m.id, { ...m, source_list_data: _sd })
                    }
                    reloadFn()

                } else {
                    setElementList(lst => {
                        let _el = [...lst]
                        _el.splice(i, 1)
                        return _el
                    })

                }
            }
        }
        childRefDelete.current.confirmDelete('Cancella Gara', `Sei sicuro di voler cancellare la gara e tutti i risultati già registrati: <b>${r.match_name}</b>`, cb)
    }
    const showCowlist = (elem, index) => {
        if (elem.link_to_category) {
            cowlistRef.current.onOpen(elem.cow_list, { ...elem, title: elem.match_name + " " + elem.match_description, lock: true, source_cow_list: cow_list.filter(c => c.category && c.category.id === elem.linked_category?.id) }, index)
        } else {
            cowlistRef.current.onOpen(elem.cow_list, { ...elem, title: elem.match_name + " " + elem.match_description, lock: true }, index)
        }
    }

    const doSplit = async (el, nl) => {
        if (event_status && el.id === event_status.cur_match?.id) {
            setCurrentMatchLive(el)
        }
        console.log("split MATCH", el, nl)
        const resb = await edit_Match(user.uid, selEvent.id, el.id, el)

        if (nl) {
            const res = await add_Match(user.uid, selEvent.id, nl)
            if (res) {
                const lm = element_list.filter(m => m.source_list_data && m.source_list_data[el.id])
                for (const m of lm) {
                    console.log("EDIT LINKED MATCH", m)
                    await edit_Match(user.uid, selEvent.id, m.id, { ...m, source_list_data: { ...m.source_list_data, [res]: { ...m.source_list_data[el.id] } } })
                }
            }
        }
        reloadFn()
    }

    const addFn = async (el) => {
        console.log("EDIT/ADD", el, user, selEvent.id,)
        if (el.id) {
            /*             // create copy
                        const _original_id = el.id
                        let _el = { ...el }
                        delete _el.id
                        _el.name = _el.name + " 2"
                        const res = await add_Match(user.uid, selEvent.id, _el)
                        const other_source = element_list.filter(m => m.source_list_data[_original_id])
                        if (other_source.length > 0) {
                            for (const m of other_source) {
                                let _m = { ...m }
                                let d = { ...m.source_list_data[_original_id] }
                                _m.source_list_data[res] = { ...d }
                                edit_Match(user.uid, selEvent, m.id, _m)
                            }
                        } */

        } else {
            const res = await add_Match(user.uid, selEvent.id, el)
            console.log("RES", res)
        }
        reloadFn()
    }
    const editFn = async (el) => {
        if (event_status && el.id === event_status.cur_match?.id) {
            setCurrentMatchLive(el)
        }
        console.log("EDIT MATCH", el)
        const res = await edit_Match(user.uid, selEvent.id, el.id, el)
        reloadFn(el)
    }

    const handleExport = () => {
        exportRef.current.onOpen(element_list )
    }

    const handleCleanData = () => {
        const cb = async () => {
            setIsLoading(true)
            const res = await clear_all_matches(selEvent.id)
            console.log("RES", res)
            setElementList([])
        }
        childRefDelete.current.confirmDelete('Cancella tutte le gare  ', `Sei sicuro di voler cancellare <b>TUTTE LE GARE</b>? <br/> quest'azione non è annullabile`, cb)
    }


    const handleSqualified = () => {
        squalifiedRef.current.onOpen(element_list)
    }

    const addCowList = (add_cow_data) => {
        const old_el = getSelectedElement(add_cow_data.id, element_list, 'id')
        const new_el = { ...old_el, cow_list: add_cow_data.cow_list }
        console.log(new_el, add_cow_data, old_el)
        editFn(new_el)
    }

    const reloadFn = async (el) => {
        if (el) {
            setElementList(lst => {
                const c = checkComponentPresence(el, element_list, 'id')
                let _el = [...lst]
                if (c >= 0) {
                    _el.splice(c, 1, el)
                } else {

                }
                return _el
            })


        } else {
            setIsLoading(true)
            const data = await get_Match_list(selEvent.id)
            setElementList(data.filter(d => !d.is_temp).sort(propComparatorDateTime('planned_start')))
        }
    }



    const initData = async () => {
        const data = await get_Category_list(selEvent.id)
        console.log("CATEGORY LIST", data)
        setCategoryList(data.sort(propComparator('category_number')))
    }


    useEffect(() => {
        let unsubscribe = () => {
            setCowList([])
        }
        console.log("SEL EVENT", selEvent)
        if (selEvent.id) {

            initData()
            reloadFn()

            document.title = 'ShowTime ANAFIBJ - gestione gare';

            const ev_callback = (cur_session) => {
                console.log("CUR SESSION", cur_session)
                unsubscribe = setEventStatus(cur_session)
            }
            const ev_callback_cow = (cow_dict_data) => {
                console.log("CUR cow live data ", cow_dict_data)
                setCowList(el => {
                    let _el = [...el]
                    if (cow_dict_data.removedList.length > 0) {
                        const r_index_list = cow_dict_data.removedList.map(c => c.id)
                        _el = _el.filter(e => !r_index_list.includes(e.id))
                    }
                    if (cow_dict_data.modifiedList.length > 0) {
                        const _el_index_list = _el.map(c => c.id)
                        for (const m of cow_dict_data.modifiedList) {
                            const c = _el_index_list.indexOf(m.id)
                            _el.splice(c, 1, m)
                        }
                    }
                    if (cow_dict_data.addedList.length > 0) {
                        const _el_index_list = _el.map(c => c.id)
                        for (const m of cow_dict_data.addedList) {
                            const c = _el_index_list.indexOf(m.id)
                            if (c < 0) {
                                _el.push(m)
                            } else {
                                _el.splice(c, 1, m)
                            }
                        }
                    }
                    // _el = [...el, ...cow_dict_data.addedList]
                    //FIX ANAFI
                    //_el.sort(propComparator('catalog_id'))
                    _el.sort(propComparatorDate('birthdate', true, 'catalog_id'))
                    _el.reverse()
                    return _el
                })
                //            unsubscribe = setElementList(cow_dict_data)
            }

            const initLive = async () => {
                if (selEvent.id) {
                    const es = await get_event_status_live(selEvent.id, ev_callback)
                    const cs = await get_cows_live(selEvent.id, ev_callback_cow)
                }
            }
            initLive()
        }

        return () => {
            try {
                unsubscribe()
            } catch (err) {

            }
        }

    }, [selEvent])



    const saveMatchlistAsTemplate = (nm) => {
        console.log("SAVE TMPL AWARD")
        add_match_complete_template(user.uid, { name: nm, value: element_list.map(m => cleanMatch(m)) })
    }

    const loadListFromTemplate = async (t) => {
        const res = await clear_all_matches(selEvent.id)
        console.log(res)
        for (const a of t.value) {

            await edit_Match(user.uid, selEvent.id, a.id, cleanMatch(a))
        }
        console.log("LOAD", t)
        reloadFn()
    }


    const load_listFn = async () => {
        const res = await get_match_complete_template_list()
        return res.sort(propComparator('name'))
    }


    const setCurrentMatchLive = (m) => {
        if (m) {
            set_event_status(selEvent.id, {
                cur_match: {
                    match_name: m.match_name,
                    match_description: m.match_description,
                    id: m.id,
                    award_label_list: m.award_label_list || [],
                    award_list: m.award_list || [],
                    result_list: m.result_list || []
                }
            })

        } else {
            set_event_status(selEvent.id, {
                cur_match: {
                    match_name: '',
                    match_description: ''
                }
            })
        }

    }

    const getMatchColor = (match) => {
        if (match.use_dynamic_list) {

        } else if (match.link_to_category) {
            let cl = cow_list.filter(c => c.category && c.category.id === match.linked_category?.id)
            let cl_pres = cl.filter(c => c.is_present)
            if (cl.length === 0) {
                return 'red'
            } else {
                return 'black'
            }

        } else {
            const l = match.cow_list?.length
            if (l === 0) {
                return '#aaa'
            } else if (l === 1) {
                return 'orange'
            } else {
                return 'black'
            }
        }
    }
    const ExportCSVContent = () => {
        return <ExportCSV
            data={collectCowResults(undefined, true)}
            cow_list={cow_list}
            fileName={`${selEvent.event_name}_soggetti.csv`}
            title={`PRESENTI ALLA MOSTRA ${selEvent.event_name} del ${myFormat(selEvent.event_start, 'dd/MM/yyyy')}`}
        />
    }


    const collectCowResults = (fm, onlyPoint) => {
        let cow_dict = {}
        let _cow_list = []
        for (const m of element_list) {
            console.log("MATCH", m)
            if (m.link_to_category) {

            }
            if (m.use_dynamic_list) {

            }
            if (m.match_type === 'normal' && m.result_list) {
                for (const r of m.result_list) {
                    console.log("result list", r)
                    if (r && !r.from_other_data) {
                        const award = getSelectedElement(r.id, m.award_list, 'id')
                        console.log("pre---AWARD", award)
                        let c_list = r.cow_list.map((c, k) => {
                            if (!award.has_position) {
                                console.log("AWARD", award)
                            }
                            console.log("COLLECT COW: do_insert_data", c.cow && (m.overflow_as_limit || k < m.export_position_limit))
                            if (c.cow && (m.overflow_as_limit || parseInt(m.export_position_limit) === 0 || k < m.export_position_limit)) {
                                const cow = getSelectedElement(c.cow.id, cow_list, 'id')
                                if (!cow_dict[c.cow.id]) {
                                    cow_dict[c.cow.id] = { ...cow, total_point: 0, export_description: '' }
                                }
                                const als = getAwardLabel(c.position_id, m.award_label_list, true)
                                const t_point = award.point_list && award.point_list[k] ? award.point_list[k] : 0
                                const data = {
                                    cow: cow,
                                    match_point: t_point,
                                    award_description: award.has_position ? getAwardDescription(m, c.position_id, als, m.match_shortname) : 'MIG.MAM.,',
                                    match_data: {
                                        name: m.match_name,
                                        shortname: m.match_shortname,
                                        award: award.award_name,
                                        has_position: award.has_position,
                                        award_label: getAwardLabel(c.position_id, m.award_label_list),
                                        award_shortlabel: als,
                                        position_id: c.position_id,
                                        position: k
                                    }
                                }
                                cow_dict[cow.id].total_point += t_point
                                cow_dict[cow.id].export_description += data.award_description
                                console.log("ALS", als, data,)
                                return data

                            } else {
                                return undefined
                            }
                        }).filter(c => c !== undefined)
                        _cow_list = [..._cow_list, ...c_list]
                    }
                }
            }

        }
        if (!onlyPoint) {
            const ev_date = format(myTimestampToDate(selEvent.event_start), 'yyyyMMdd')
            let txt_data = ''
            console.log("EVENTDATA...", selEvent)
            const end = fm === 'dos' ?'\r': '\n'
            for (const t in cow_dict) {
                const cow = cow_dict[t]

                //const real_cow = getSelectedElement(cow, cow_list, 'id')
                //console.log("COW", cow, real_cow)
                if (cow.id) {
                    const c_data = [
                        cow.breed,
                        cow.serial,
                        ev_date,
                        selEvent.event_category,
                        selEvent.location?.address_cap,
                        `${cow.catalog_id}`.padStart(4, '0'),
                        category_section[cow.category?.category_number],
                        `${cow.category?.category_number}`.padStart(2, '0'),
                        `${cow.property?.cdaua}`.padStart(7, '0'),
                        selEvent.location?.address_state_short,
                        `${cow.total_point}`.padStart(4, '0'),
                        cow.export_description]
                    //console.log(c_data)
                    txt_data += c_data.join("") + end
                }
            }

            console.log("EXPORT COWLIST", _cow_list.map(c => c.award_description))
            const element = document.createElement("a");
            const file = new Blob([txt_data], {
                type: "text/plain"
            });
            element.href = URL.createObjectURL(file);
            element.download = `showtimeANAFIBJ-export_${ev_date}_${selEvent.event_name}.txt`;
            document.body.appendChild(element);
            element.click();
        } else {
            return Object.values(cow_dict)
        }
    }

    const cowlistBtn = (match, index) => {
        let variant = match.cow_list?.length === 0 ? 'outlined' : 'contained'

        if (match.use_dynamic_list) {
            let _data = initCowlist(match, element_list, [])
            const not_completed = _data.not_completed
            const _cow_list = _data.cow_list

            /* const s_key = Object.keys(match.source_list_data)
            const m_list = element_list.filter(e => s_key.includes(e.id))
            let _cow_list = []
            let _cow_id_list = []
            const not_completed = m_list.filter(e => e.status !== 'end').length
            //for (const m of m_list.filter(e => e.status === 'end')) {
            for (const m of m_list) {
                const a = match.source_list_data[m.id]
                const a_data = Object.entries(a)
                const aw_list = a_data.map(ak => (
                    { ...ak[1], ...getSelectedElement(ak[0], m.award_list, 'id') }
                ))
                for (const award of aw_list.sort(propComparator('order'))) {
                    const result = getSelectedElement(award.id, m.result_list, 'id')
                    //                        const award = getSelectedElement(ak[0], m.award_list, 'id')
                    let c_list = []
                    c_list = result.cow_list?.filter(c => !c.squalified)
                    if (c_list) {
                        if (award.filter_applied === 'red') {
                            c_list = c_list.filter(c => c.cow?.cow_type === 'red')
                        } else if (award.filter_applied === 'black') {
                            c_list = c_list.filter(c => c.cow?.cow_type === 'black')
                        }
                    }

                    if (c_list?.length > 0) {
                        if (award.has_position) {
                            for (const p of award.position_list) {
                                const c = c_list[p - 1]
                                if (c) {
                                    const award_data = {
                                        match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: c.position_id + 1,
                                        award_label: getAwardLabel(c.position_id, m.award_label_list)
                                    }
                                    const c_pos = _cow_id_list.indexOf(c.cow.id)
                                    if (c_pos >= 0) {
                                        let ccc = { ..._cow_list[c_pos] }
                                        ccc.award_source_list.push(award_data)
                                        _cow_list.splice(c_pos, 1, ccc)
                                    } else {
                                        const new_cow = {
                                            ...m.cow,
                                            award_source_list: [
                                                award_data
                                            ]
                                        }
                                        _cow_list.push(new_cow)
                                        _cow_id_list.push(c.cow.id)
                                    }
                                }

                            }

                        } else {
                            for (const c of c_list) {
                                if (c !== undefined) {


                                    const award_data = {
                                        match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: c.position_id + 1,
                                        award_label: award.award_name
                                    }
                                    console.log("COW LISTR", c)
                                    if (c.cow) {

                                        const c_pos = _cow_id_list.indexOf(c.cow.id)
                                        console.log(award_data)
                                        if (c_pos >= 0) {
                                            let ccc = { ..._cow_list[c_pos] }
                                            ccc.award_source_list.push(award_data)
                                            _cow_list.splice(c_pos, 1, ccc)
                                        } else {
                                            const new_cow = {
                                                ...m.cow,
                                                award_source_list: [
                                                    award_data
                                                ]
                                            }
                                            _cow_list.push(new_cow)
                                            _cow_id_list.push(c.cow.id)
                                        }
                                    }
                                }
                            }
                        }
                        //_cow_list = [..._cow_list, ...c_list]
                    }
                } 



            }*/

            return (
                <SideBadge
                    color={getSourceColor(match)}
                    showZero
                    badgeContent={match.source_list_data ? Object.keys(match.source_list_data).length : '0'}
                >
                    <HtmlTooltip arrow title={<><Typography >lista dinamica da {match.source_list_data ? Object.keys(match.source_list_data).length : '0'} gare</Typography>
                        {match.award_list?.filter(a => a.from_other_data).length > 0 ? <> (<Functions sx={{ fontSize: '1em' }} />risultati da punteggio)</>
                            :
                            <>
                                <br /><b>{match.cow_list?.length || _cow_list.length}</b> soggetti attualmente inseriti
                            </>
                        }
                        <br />{not_completed > 0 && <><Warning sx={{ fontSize: '1em' }} />{not_completed} gare non completate</>}
                    </>
                    }>
                        <span>
                            {match.award_list?.filter(a => a.from_other_data).length > 0 ?
                                <Chip color="light" variant={variant} size="small" avatar={not_completed > 0 && <Warning sx={{ fontSize: '1em' }} />} label={
                                    <>
                                        da punteggio
                                        <Functions sx={{ fontSize: '1em' }} />
                                    </>
                                }>
                                </Chip>
                                :
                                <Chip color="primary" variant={variant} size="small" avatar={not_completed > 0 && <Warning sx={{ fontSize: '1em' }} />}
                                    label={<>
                                        {match.cow_list?.length || _cow_list.length}
                                        <Repartition fontSize="1em" />
                                    </>}>
                                </Chip>
                            }
                        </span>
                    </HtmlTooltip>
                </SideBadge>
            )

        } else if (match.link_to_category) {
            let cl = cow_list.filter(c => c.category && c.category.id === match.linked_category?.id)
            let cl_pres = cl.filter(c => c.is_present)
            let cl_real = []
            if (match.cow_list?.length > 0) {
                cl_real = match.cow_list
            } else {
                cl_real = cl_pres
            }
            return (
                <SideBadge
                    color={cl.length === 0 ? 'error' : "warning"}
                    showZero
                    badgeContent={cl.length}
                >
                    <HtmlTooltip arrow title={<>lista collegata alla categoria <br /><Typography >{match.linked_category?.category_name}</Typography>

                        <br /><b>{cl_pres.length}</b> soggetti presenti
                        <br />su {cl.length} soggetti totali in categoria
                        {match.cow_list?.length === 0 ? '' : <><br /><b>{match.cow_list?.length}</b> soggetti confermati in gara </>}
                    </>
                    }>
                        <span>
                            <Chip color="secondary" variant={variant} size="small"
                                label={
                                    <>
                                        {cl_real.length}
                                        <InsertLink sx={{ fontSize: '1em' }} />
                                    </>
                                }
                            >

                            </Chip>
                        </span>
                    </HtmlTooltip>
                </SideBadge>
            )

        } else {
            return (
                <Button color="secondary" variant={variant} onClick={() => showCowlist(match, index)} size="small">
                    {match.cow_list?.length}
                </Button>
            )
        }
    }


    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>
            <DeleteconfirmationSection ref={childRefDelete} />
            <MatchDialog ref={dialogRef} addFn={addFn} editFn={editFn} event_id={selEvent.id} element_list={element_list} category_list={category_list} />
            <CowSublistDialog ref={cowlistRef} handleAddCowList={addCowList} match element_list={element_list} editFn={editFn} />
            <MatchResultDialog ref={resultRef} editFn={editFn} match_list={element_list} event_status={event_status} handleDoSplit={doSplit} />
            <AwardListDialog ref={awardListRef} />
            <AwardListPointDialog element_list={element_list} ref={awardListPointRef} cow_list={cow_list} />
            <MatchSplitDialog ref={splitRef} editFn={editFn} />
            <MatchDocumentsDialog ref={documentRef} cow_list={cow_list} />
            <ExportDataDialog cow_list={cow_list} ref={exportRef} />
            <CowSqualifiedDialog ref={squalifiedRef} cow_list={cow_list} editFn={editFn}/>
            <>

                <ElevationScroll>

                    <AppBar style={globalstyles.secondaryAppBar}>

                        <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                            <Grid size={2} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                                Lista gare
                                <Chip size="small" label={<>{element_list.length}</>} />
                            </Grid>
                            <Grid size={"grow"} sx={{ textAlign: "right" }}>
                                <ButtonGroup size="small">
                                    <Tooltip title="apri Proietta risultati">
                                        <Button  variant="contained" target="_blank" href={`screen`} startIcon={<ScreenShare />}></Button>
                                    </Tooltip>

                                    <TemplateMenu
                                        label="template lista gare"
                                        saveAs={element_list.length > 0 && saveMatchlistAsTemplate}
                                        loadTemplate={loadListFromTemplate}
                                        load_listFn={load_listFn}
                                        element_name="gare"
                                    />
                                    <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuova gara</Button>
                                    <MatchpageMenu
                                        handleClean={handleCleanData}
                                        handlePdf={handlePdfDocs}
                                        show={element_list.length > 0}
//                                        handleExport={collectCowResults}
                                        handleExport={handleExport}
                                        ExportCSV={ExportCSVContent}
                                        category_list={category_list}
                                        handleSqualified={handleSqualified}
                                    />
                                </ButtonGroup>

                            </Grid>
                        </Grid>
                        {!isLoading && element_list.length>0 &&
                                <Grid container sx={globalstyles.listHeader}>
                                    <Grid size="grow">
                                        nome
                                        <Box style={{ fontSize: '0.7em' }}>descrizione</Box>
                                    </Grid>
                                    <Grid size="grow">
                                        ora inizio previsto
                                        <Box style={{ fontSize: '0.7em' }}>inizio-fine (reali)</Box>
                                    </Grid>
                                    <Grid size="grow">
                                        premi
                                        <Box style={{ fontSize: '0.7em' }}>Tipolgia - Nome - filtri - punteggi</Box>
                                    </Grid>
                                    <Grid size={1}>
                                        etichette posizioni
                                    </Grid>
                                    <Grid size="grow">
                                        soggetti
                                    </Grid>
                                    <Grid size={2} >
                                        {event_status?.cur_match?.id !== undefined &&
                                            <Tooltip title={`rimuovi gara in corso`}>
                                                <Button variant={"contained"} color={'success'} size="small" onClick={() => setCurrentMatchLive()} startIcon={<Stop />}></Button>
                                            </Tooltip>
                                        }
                                    </Grid>
                                </Grid>
                        }
                    </AppBar>
                </ElevationScroll>
            <Toolbar style={{marginBottom: '15px'}} />
                {isLoading ?
                    <LinearProgress />
                    :
                    <>
                        {element_list.length === 0 ?
                            <Typography sx={globalstyles.missing_value}>
                                Nessuna gara inserita
                            </Typography>
                            :
                            <>
                                <Grid style={{ paddingBottom: 10 }}>
                                    {element_list.map((s, k) => (
                                        <OneMatch
                                            is_current={event_status?.cur_match?.id === s.id}
                                            key={k}
                                            match={s}
                                            index={k}
                                            match_color={getMatchColor(s)}
                                            CowlistBtn={cowlistBtn(s, k)}
                                            handleEdit={handleEdit}
                                            handleDelete={handleDelete}
                                            handlePlay={setCurrentMatchLive}
                                            handleShow={showAwardList}
                                            handleRun={handleRun}
                                            handleDocs={handleDocs}
                                            _award_filter_subdict={_award_filter_subdict}
                                            handleSplit={handleSplit}
                                        />
                                    ))}
                                </Grid>
                            </>}
                    </>}
            </>
        </Box >
    );
}

const getSourceColor = (match) => {
    if (!match.source_list_data) {
        return 'error'
    } else if (match.complete_source_list === true) {
        return 'success'
    } else {
        return 'primary'
    }
}

const OneMatch = ({ match, index, handleDelete, handleEdit, handlePlay, is_current, handleRun, CowlistBtn, handleDocs, viewMode, handleShow, match_color, _award_filter_subdict }) => {
    const matches_width = useMediaQuery('(min-width:1080px)');


    let matchIcon = <></>
    let matchstatus = ''
    if (match.match_type === 'auto') {
        matchIcon = <Functions />
        matchstatus = ' assegnazione automatica'
    } else {
        if (match.status === 'pre') {
            matchIcon = <Checklist sx={{ color: 'orange' }} />
            matchstatus = ' (controllo presenze)'
        } else if (match.status === 'run') {
            matchIcon = <PlayArrow sx={{ color: 'lightgreen' }} />
            matchstatus = ' (gara in corso)'
        } else if (match.status === 'end') {
            matchIcon = <Stop sx={{ color: 'red' }} />
            matchstatus = ' (gara terminata)'
        }
    }




    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, color: match_color }}>
            <Grid size="auto">
                <MyPrivateIcon is_private={match.is_public !== true} />
                <RunningMode running={match.public_partial_source} />
            </Grid>
            <Grid size={"grow"} container flexDirection={"column"}>
                <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                    {match.match_name}
                </Grid>
                <Grid size={"grow"} sx={{ fontSize: '0.7em' }}>
                    {match.match_description}
                </Grid>
            </Grid>
            <Grid size={"grow"}>
                <Typography sx={{ fontSize: '0.7em' }} as="span">
                    {format(myTimestampToDate(match.planned_start), 'dd/MM')}&nbsp;
                </Typography>
                {format(myTimestampToDate(match.planned_start), 'HH:mm')}
                <Box style={{ fontSize: '0.7em' }}>
                    {match.real_start &&
                        <>
                            {format(myTimestampToDate(match.real_start), 'HH:mm')}
                        </>
                    }
                    {match.real_end &&
                        <>
                            &nbsp;-&nbsp;{format(myTimestampToDate(match.real_end), 'HH:mm')}
                        </>
                    }
                </Box>
            </Grid>
            <Grid size={"grow"}>
                {match.award_list?.map((a, k) => (
                    <Grid key={k} container sx={{ ...globalstyles.list_row, ...k === match.award_list.length - 1 && { borderBottom: 'none' } }}>
                        <Grid size={"grow"} sx={{ fontSize: '0.7em', textAlign: "left" }} alignItems={"center"}>
                            {a.from_other_data &&
                                <Tooltip title="da dati esterni">
                                    <DatasetLinked sx={{ fontSize: '1em' }} />
                                </Tooltip>
                            }
                            {a.has_position ?
                                <Tooltip title="usa posizioni">
                                    <FormatListNumbered sx={{ fontSize: '1em' }} />
                                </Tooltip>
                                :
                                <Tooltip title="premio singolo">
                                    <MilitaryTech sx={{ fontSize: '1em' }} />
                                </Tooltip>
                            }
                            {a.award_name}
                        </Grid>
                        <Grid size={"grow"}>
                            {a.filter_data_list?.sort().map((f, k) => (
                                <Chip key={k} label={_award_filter_subdict[f]?.label} color={_award_filter_subdict[f]?.color} size="small" />
                            ))}
                        </Grid>
                        <Grid size="auto">
                            {a.hide_from_screen && <VisibilityOff sx={{fontSize: '0.9em', color: 'orange'}}/> }
                            </Grid>
                        <Grid size={1} sx={{ fontSize: '0.7em', textAlign: "left" }} >
                            {a.point_list && a.point_list.length > 0 &&
                                <Tooltip arrow placement="right" title={
                                    <>
                                        <b>Punteggi</b>
                                        {a.point_list.map((p, pk) => (
                                            <Typography key={pk} sx={{ fontSize: '0.8em' }}>
                                                pos {pk + 1}:  pt {p}
                                            </Typography>
                                        ))}
                                    </>
                                }>
                                    <Scoreboard sx={{ fontSize: '1em' }} />
                                </Tooltip>
                            }
                        </Grid>
                    </Grid>
                ))}
            </Grid>
            <Grid size={1}>
                {match.award_label_list &&
                    <HtmlTooltip arrow placement="right" title={
                        <>
                            <b>Etichette premi</b>
                            {match.award_label_list.map((p, pk) => (
                                <Typography key={pk} sx={{ fontSize: '0.8em' }}>
                                    {p.position}: {p.award_name}
                                </Typography>
                            ))}
                        </>
                    }>
                        <Chip size="small" label={match.award_label_list.length} />
                    </HtmlTooltip>
                }
            </Grid>
            <Grid size={"grow"}>
                {CowlistBtn}
            </Grid>
            <Grid size={2} sx={{ textAlign: 'right' }}>
                {matches_width ?
                    <ButtonGroup size="small" fullWidth>
                        <Tooltip title={`imposta su schermo esterno come gara in corso`}>
                            <Button variant={is_current ? 'contained' : "outlined"} color={is_current ? 'success' : 'primary'} size="small" onClick={() => handlePlay(match, index)} startIcon={<PlayArrow />}></Button>
                        </Tooltip>
                        <Tooltip title={`svolgimento gara${matchstatus}`}>
                            <Button variant="contained" disabled={false} size="small" onClick={() => handleRun(match, index)} startIcon={<EmojiEvents />} endIcon={matchIcon}></Button>
                        </Tooltip>
                        <Tooltip title="modifica">
                            <Button color="warning" onClick={() => handleEdit(match, index)} startIcon={<Edit color="warning" />}></Button>
                        </Tooltip>
                        <OneMatchMenu
                            has_cow_list={match.cow_list && match.cow_list.length > 0}
                            match_status={match.status}
                            handleDelete={() => handleDelete(match, index)}
                            handleDocs={() => handleDocs(match, index)}
                            handleShow={() => handleShow(match)}
                        />
                    </ButtonGroup>
                    :
                    <>
                        <ButtonGroup fullWidth>
                            <Tooltip title={`imposta come gara in corso`}>
                                <Button variant={is_current ? 'contained' : "outlined"} color={is_current ? 'success' : 'primary'} onClick={() => handlePlay(match, index)} startIcon={<PlayArrow />}></Button>
                            </Tooltip>
                            <Tooltip title={`svolgimento gara${matchstatus}`}>
                                <Button variant="contained" onClick={() => handleRun(match, index)} startIcon={<EmojiEvents />} endIcon={matchIcon}></Button>
                            </Tooltip>
                        </ButtonGroup>
                        <ButtonGroup size="small" fullWidth sx={{ mt: 1 }}>
                            <Tooltip title="modifica">
                                <Button color="warning" onClick={() => handleEdit(match, index)} startIcon={<Edit color="warning" />}></Button>
                            </Tooltip>
                            <OneMatchMenu
                                has_cow_list={true}
                                match_status={match.status}
                                handleDelete={() => handleDelete(match, index)}
                                handleDocs={() => handleDocs(match, index)}
                                handleShow={() => handleShow(match)}
                            />
                        </ButtonGroup>
                    </>
                }
                <Grid style={{ fontSize: '0.7em' }}>
                    {match.hide_not_qualified && <>Nascondi soggetti senza premi nel report giudizi<br /></>}
                    {parseInt(match.export_position_limit) !== 0 &&
                        <>
                            numero massimo posizioni esportate: {match.export_position_limit}<br />
                            {match.overflow_as_limit &&
                                <>

                                    esporta soggetti oltre il limite e assegna la posizione {match.export_position_limit}
                                </>
                            }
                        </>
                    }
                </Grid>
            </Grid>
        </Grid>

    )
}





